import request from '@/utils/request'


// 查询病情干预列表
export function listIllnessIntervene(query) {
  return request({
    url: '/biz/illness-intervene/list',
    method: 'get',
    params: query
  })
}

// 查询病情干预分页
export function pageIllnessIntervene(query) {
  return request({
    url: '/biz/illness-intervene/page',
    method: 'get',
    params: query
  })
}

// 查询病情干预详细
export function getIllnessIntervene(data) {
  return request({
    url: '/biz/illness-intervene/detail',
    method: 'get',
    params: data
  })
}

// 新增病情干预
export function addIllnessIntervene(data) {
  return request({
    url: '/biz/illness-intervene/add',
    method: 'post',
    data: data
  })
}

// 修改病情干预
export function updateIllnessIntervene(data) {
  return request({
    url: '/biz/illness-intervene/edit',
    method: 'post',
    data: data
  })
}

// 删除病情干预
export function delIllnessIntervene(data) {
  return request({
    url: '/biz/illness-intervene/delete',
    method: 'post',
    data: data
  })
}

export function queryMenuList(query) {
  return request({
    url: '/biz/illness-intervene/queryMenuList',
    method: 'get',
    params: query
  })
}
